/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./changeLive.vue?vue&type=template&id=5f768e20&scoped=true&"
import script from "./changeLive.vue?vue&type=script&lang=js&"
export * from "./changeLive.vue?vue&type=script&lang=js&"
import style0 from "./changeLive.vue?vue&type=style&index=0&id=5f768e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f768e20",
  null
  
)

export default component.exports